/**
 * Imports the necessary React components and libraries for the Depot page.
 * @module DepotPage
 * @requires React
 * @requires CSmartTable
 * @requires useTranslation
 * @requires Card
 * @requires CreateDepot
 * @requires UpdateDepot
 * @requires CustomToggleButton
 * @requires Breadcrumbs
 * @requires ConfirmModal
 * @requires EmptyCell
 */
import React from "react";
import { CSmartTable } from "@coreui/react-pro";
import { useTranslation } from "react-i18next";
import Card from "react-bootstrap/Card";

import CreateDepot from "./createDepot";
import UpdateDepot from "./updateDepot";

import EmptyCell from "../../components/emptyCell/emptyCell";
import ConfirmModal from "../../components/confirmModal/confirmModel";
import CustomButton from "../../components/customButton/customButton";
import CustomeShimer from "../../components/customeShimer/customeShimer";
import Breadcrumbs from "../../components/customBreadcrumb/customBreadcrumb";
import CustomLoadingHTML from "../../components/customLoadingHTML/customLoadingHTML";
import CustomToggleButton from "../../components/customToggleButton/customToggleButton";

// import "./depotsManagement.scss";
import Constant from "../../util/constant";
import { Link } from "react-router-dom";

/**
 * A component that renders the Depots Management page.
 * @param {{object}} props - The component props.
 * @param {{function}} props.showCreateDepotModal - Function to show the create depot modal.
 * @param {{function}} props.closeCreateDepotModal - Function to close the create depot modal.
 * @param {{function}} props.openCreateDepotModal - Function to open the create depot modal.
 * @param {{function}} props.createDepotFun - Function to create a depot.
 * @param {{function}} props.showUpdateDepotModal - Function to show the update depot modal.
 * @param {{function}} props.closeUpdateDepotModal - Function to close the update depot modal.
 * @param
 */
const DepotsManagementComponent = (props) => {
  const { t } = useTranslation();

  /**
   * Destructures the properties from the given props object.
   * @param {{object}} props - The props object containing the properties to destructure.
   * @returns None
   */
  const {
    showCreateDepotModal,
    closeCreateDepotModal,
    openCreateDepotModal,
    createDepotFun,
    showUpdateDepotModal,
    closeUpdateDepotModal,
    updateDepotFun,
    depotData,
    columns,
    placeHolderShimer,
    onCheckAction,
    onUpdateDepot,
    openDeleteUserModal,
    noDataTitle,
    noDataDesc,
    clearSearchButton,
    onHide,
    showStatusModal,
    onProcced,
    closeDeactiveModal,
    showDeleteUserModal,
    onDeleteUser,
    closeDeleteUserModal,
    noDataFound,
    noDataAddButtonTitle,
    emptyDataAddButton,
    updateDepotFunction,
    clearUpdateData,
    smarttableref,
    tableFilterHeight,
    breadcrumbHeight,
    tabHeaderHeight,
    headerHeight,
    dimensions,
    loaderHtml,
    tableContainerRef,
    itemsPerPage,
    handleUpdateFormSubmit,
    handleFormSubmit,
    loadingbutton,
    loadingscroll,
    createDepotLoaderButton,
    createDepotModelLoaderButton,
    updateDepotModelLoaderButton,
    disableModelLoaderBotton,
    updateDepotsValue,
    setUpdateDepotValue,
    issetupdateDepotValue,
    searchFilterClear,
    searchValue,
    onTableFilterChange,
    handledepottextChange,
    depottextcount,
    clearCreatData,
    createValues,
    createDepotFunction,
    updatetextcount,
    handleupdatetextChange,
    searchedData
  } = props;
  return (
    <>
      {/**
       * Renders a React component that displays a page with a depot table.
       * @returns {React.Fragment} - The rendered React component.
       */}
      <React.Fragment>
        <div className="page-content Depot">
          <Breadcrumbs
            breadcrumbInner={false}
            breadcrumbMainTitle={true}
            breadcrumbItem={t("DEPOTS")}
          />
          <Card
            className={
              loadingscroll
                ? "Main_Card Main_Depote LoadingTable"
                : "Main_Card Main_Depote"
            }
          >
            <Card.Body className="p-0 activeTabSupplier">
              <div className="Main_Card_Body">
                <div className="Card-Button">
                  <CustomButton
                    color="primary"
                    className="btn-block btn btn-primary Fill_Button"
                    onClick={() => openCreateDepotModal(true)}
                    loading={createDepotLoaderButton}
                  >
                    {t("CREATE_DEPOTS")}
                  </CustomButton>
                  <div>
                    
                  </div>
                </div>
                <CSmartTable
                  ref={smarttableref}
                  cleaner
                  clickableRows
                  columns={columns}
                  columnFilter={false}
                  columnSorter={true}
                  items={depotData}
                  itemsPerPage={itemsPerPage}
                  scopedColumns={{
                    name: (item) => {
                      const limitedContent = item?.name;
                      return (
                        <>
                          <td
                            className={
                              item?.depotstatus === Constant.GENERALKEYS.INACTIVE && "disableTd"
                            }
                          >
                            <p className={`${
                                 limitedContent.length >= 20 && !limitedContent.includes(' ')
                                  ? 'breakeAll'
                                  : 'wordBrake'
                              }`}>
                              {placeHolderShimer && <CustomeShimer />}
                              {limitedContent}
                            </p>
                          </td>
                        </>
                      );
                    },
                    noofmanagers: (item) => {
                      const itemData = JSON.stringify(item);
                      return (
                        <td
                          className={item?.depotstatus === Constant.GENERALKEYS.INACTIVE && "disableTd"}
                        >
                          <div className="depot-Wrapper">
                            {placeHolderShimer && <CustomeShimer />}
                            <Link to={`/usersManagement?itemData=${encodeURIComponent(itemData)}`}>
                            {item?.noofmanagers}
                              <i className="dripicons-chevron-right"></i>
                              </Link>
                          </div>
                        </td>
                      );
                    },
                    noofdrivers: (item) => {
                      const itemData = JSON.stringify(item);
                      return (
                        <td
                          className={item?.depotstatus === Constant.GENERALKEYS.INACTIVE && "disableTd"}
                        >
                          <div className="depot-Wrapper" >
                            {placeHolderShimer && <CustomeShimer />}
                            <Link to={`/usersManagement?itemData=${encodeURIComponent(itemData)}`}>
                            {item?.noofdrivers}
                              <i className="dripicons-chevron-right"></i>
                              </Link>
                          </div>
                        </td>
                      );
                    },
                    depotstatus: (item) => {
                      return (
                        <td
                          className={item?.depotstatus === Constant.GENERALKEYS.INACTIVE && "disableTd"}
                        >
                          <div className="ActionWrapper">
                            {placeHolderShimer && <CustomeShimer />}
                            <CustomToggleButton
                              id=""
                              checked={item?.depotstatus === Constant.GENERALKEYS.ACTIVE ? true : false}
                              onCheckChange={(e) => {
                                onCheckAction(e, item);
                              }}
                            />
                            <button
                              className="Edit-Buttton"
                              onClick={(e) => {
                                onUpdateDepot(e, item);
                              }}
                            >
                              <i
                                className="mdi mdi-pencil-outline font-size-24"
                                id="deletetooltip"
                              ></i>
                            </button>
                            <button
                              className="Delete-Buttton"
                              onClick={(e) => {
                                openDeleteUserModal(e, item);
                              }}
                            >
                              <i
                                className="mdi mdi-Delete-outline font-size-24"
                                id="deletetooltip"
                              ></i>
                            </button>
                          </div>
                        </td>
                      );
                    },
                  }}
                  tableFilter
                  onTableFilterChange={onTableFilterChange}
                  tableFilterLabel={
                    searchValue?.length > 0 && (
                      <button
                        onClick={searchFilterClear}
                        className="btn-close"
                      ></button>
                    )
                  }
                  tableFilterPlaceholder={t("SEARCH_BY_DEPOT_NAME")}
                  tableProps={{
                    className: depotData?.length === 0 || searchedData?.length === 0 ? "depotTable emptySearchTable" : "depotTable",
                    responsive: true,
                    striped: false,
                    hover: false,
                  }}
                  noItemsLabel={
                    !placeHolderShimer &&
                    <EmptyCell
                      emptyItems={depotData}
                      noDataTitle={
                        depotData?.length === 0 ? noDataFound : noDataTitle
                      }
                      noDataAddButton={true}
                      noDataAddButtonTitle={noDataAddButtonTitle}
                      noDataDesc={noDataDesc}
                      emptyDataAddButton={emptyDataAddButton}
                      clearSearchButton={clearSearchButton}
                    />
                  }
                  tableBodyProps={{
                    className: "align-middle Table-Body-scroll",
                    style: {
                      height:
                        dimensions.height -
                        headerHeight -
                        breadcrumbHeight -
                        tableFilterHeight -
                        tabHeaderHeight -
                        (loadingscroll && loaderHtml) -
                        100,
                    },
                    ref: tableContainerRef,
                  }}
                />
                {loadingscroll && <CustomLoadingHTML />}
              </div>
            </Card.Body>
          </Card>
        </div>
      </React.Fragment>

      {/**
       * Renders a confirmation modal component for deactivating a depot.
       * @param {{string}} className - The class name for the modal component.
       * @param {{boolean}} isModelIcon - Determines if an icon should be displayed in the modal.
       * @param {{function}} onHide - The function to be called when the modal is hidden.
       * @param {{string}} iconColor - The color of the icon to be displayed.
       * @param {{string}} iconCricle - The class name for the circle icon.
       * @param {{string}} modalTitle - The title of the modal.
       * @param {{string}} modalDescription - The description text of the modal.
       * @param {{boolean}} isUnderline - Determines if the
       */}
      <ConfirmModal
        className={"Deactivate"}
        isModelIcon={true}
        onHide={onHide}
        iconColor={"mdi mdi-toggle-switch-off-outline "}
        iconCricle={"iconCricleDelete"}
        modalTitle={t("DEACTIVATE")}
        modalDescription={t("ARE_YOU_SURE_YOU_WANT_TO_DEACTIVATE_THIS_DEPOT")}
        isUnderline={false}
        showModal={showStatusModal}
        leftBtnTitle={t("YES_DEACTIVATE")}
        isFirstButton={true}
        leftBtnClass={"Deactivate-btn"}
        onProcced={onProcced}
        rightBtnClass="Cancel_Btn"
        isSecondButton={true}
        rightBtnTitle={t("NO_CANCEL")}
        rightButtonClick={closeDeactiveModal}
        loaderButtonShow={disableModelLoaderBotton}
      />

      {/**
       * Renders a confirmation modal for deleting a depot.
       * @param {{string}} modalTitle - The title of the modal.
       * @param {{string}} modalDescription - The description of the modal.
       * @param {{boolean}} isUnderline - Determines if the modal title should be underlined.
       * @param {{boolean}} showModal - Determines if the modal should be shown.
       * @param {{string}} leftBtnTitle - The title of the left button.
       * @param {{boolean}} isModelIcon - Determines if an icon should be displayed in the modal.
       * @param {{string}} iconColor - The color of the icon.
       * @param {{string}} iconCricle - The class name for the circle around the icon.
       */}
      <ConfirmModal
        modalTitle={t("DELETE")}
        modalDescription={t("ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_DEPOT")}
        isUnderline={false}
        showModal={showDeleteUserModal}
        leftBtnTitle={t("YES_DELETE")}
        isModelIcon={true}
        iconColor={"mdi mdi-delete-outline "}
        iconCricle={"iconCricleDelete"}
        leftBtnClass={"ok_Btn"}
        isFirstButton={true}
        isSecondButton={true}
        rightBtnClass="Border_Button"
        rightBtnTitle={t("NO_CANCEL")}
        onProcced={onDeleteUser}
        rightButtonClick={closeDeleteUserModal}
      />

      {/**
       * Renders a component for creating a depot.
       * @param {{boolean}} showCreateDepotModal - Determines whether the create depot modal is visible.
       * @param {{function}} closeCreateDepotModal - Function to close the create depot modal.
       * @param {{function}} createDepotFun - Function to create a depot.
       * @returns The rendered component for creating a depot.
       */}
      <CreateDepot
        showCreateDepotModal={showCreateDepotModal}
        closeCreateDepotModal={closeCreateDepotModal}
        createDepotFun={createDepotFun}
        handleFormSubmit={handleFormSubmit}
        loading={loadingbutton}
        createDepotModelLoaderButton={createDepotModelLoaderButton}
        handledepottextChange={handledepottextChange}
        depottextcount={depottextcount}
        clearCreatData={clearCreatData}
        createValues={createValues}
        createDepotFunction={createDepotFunction}
      />

      {/**
       * Renders the UpdateDepot component with the specified props.
       * @param {{boolean}} showUpdateDepotModal - Determines whether the UpdateDepot modal is visible.
       * @param {{function}} closeUpdateDepotModal - Callback function to close the UpdateDepot modal.
       * @param {{function}} updateDepotFun - Function to update the depot.
       * @param {{function}} updateDepotFunction - Function to update the depot with a form.
       * @param {{function}} clearUpdateData - Function to clear the update data.
       * @returns The rendered UpdateDepot component.
       */}
      <UpdateDepot
        showUpdateDepotModal={showUpdateDepotModal}
        closeUpdateDepotModal={closeUpdateDepotModal}
        updateDepotFun={updateDepotFun}
        updateDepotFunction={(form) => updateDepotFunction(form)}
        clearUpdateData={clearUpdateData}
        handleUpdateFormSubmit={handleUpdateFormSubmit}
        updateDepotModelLoaderButton={updateDepotModelLoaderButton}
        updateDepotsValue={updateDepotsValue}
        setUpdateDepotValue={setUpdateDepotValue}
        issetupdateDepotValue={issetupdateDepotValue}
        updatetextcount={updatetextcount}
        handleupdatetextChange={handleupdatetextChange}
      />
    </>
  );
};

export default DepotsManagementComponent;
